import { FC } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

const errorContainerStyle: React.CSSProperties = {
  display: 'inline-block',
  backgroundColor: '#ffff00cc',
  padding: '6px 16px',
  maxWidth: '100%',
};

export function ErrorFallback({ error }) {
  return (
    <div role="alert" style={errorContainerStyle}>
      <div
        style={{
          marginBottom: '8px',
          fontSize: '20px',
          fontWeight: 600,
          color: 'rgba(255, 0, 0, 0.87)',
        }}
      >
        Something went wrong:
      </div>
      <pre style={{ color: 'red' }}>{error.message}</pre>
    </div>
  );
}

export const GenericErrorBoundary: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
  );
};
